import { defineComponent as _defineComponent } from 'vue';
import { downloadExcel } from '~/functions/export';
import { useExportNkiCompanyDataLazyQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'NkiExcelExport',
  props: {
    portfolioId: {
      required: false,
      type: String
    }
  },
  emits: ['finish'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var input = computed(function () {
      var _props$portfolioId;
      return {
        input: {
          portfolioId: (_props$portfolioId = props === null || props === void 0 ? void 0 : props.portfolioId) !== null && _props$portfolioId !== void 0 ? _props$portfolioId : null
        }
      };
    });
    var _useExportNkiCompanyD = useExportNkiCompanyDataLazyQuery(input, {
        fetchPolicy: 'network-only'
      }),
      onResult = _useExportNkiCompanyD.onResult,
      refetch = _useExportNkiCompanyD.refetch,
      loading = _useExportNkiCompanyD.loading,
      load = _useExportNkiCompanyD.load;
    onResult(function (res) {
      var _res$data;
      var result = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.exportNkiCompanyData;
      if (result) {
        downloadExcel(result.base64String, result.fileName);
        emit('finish');
      }
    });
    function triggerExcelExport() {
      load() || refetch();
    }
    return {
      __sfc: true,
      emit: emit,
      props: props,
      input: input,
      onResult: onResult,
      refetch: refetch,
      loading: loading,
      load: load,
      triggerExcelExport: triggerExcelExport
    };
  }
});